<script>
  import Heading from '../Heading/Heading.svelte';
  import SubscriptionSelectionArea from './SubscriptionSelectionArea.svelte';
  import Icon from '../Icon/Icon.svelte';
  import getTranslation from '../../utilities/getTranslation';
  import IllustrationPhone from '../Subscription/IllustrationPhone.svelte';
  import { shouldShowOffer } from './helper';

  export let data, cards, componentInformationKeys;

  const showDarkBackground = data.showDarkBackground;

  const multipleSubscriptionCards = data.firstRow.productGroups.length > 1;
  const twoProductCards = data.firstRow.productGroups.length === 2;
  const threeProductCards = data.firstRow.productGroups.length === 3;
  const hasActiveSubscription = !!data.currentActiveSubscription;
</script>

<style lang="scss">
  @import '../../styles/tools/media-query';
  @import '../../styles/settings/core';
  @import '../../styles/settings/global';
  @import '../../styles/settings/colors';

  $subscription-area-purple: #48001e;
  $subscription-area-text-white: #fff4f2;

  .component-title-dark {
    margin: 0 auto spacing(8);
    text-align: center;
    display: flex;
    align-items: center;
    width: 80%;
    padding-block-start: spacing(11);
    flex-direction: column;
    margin-block-end: spacing(8);
    color: $purple-50;

    @include mq($from: tabletlandscape) {
      width: 50%;
    }

    @include mq($from: desktop) {
      max-width: 50.9rem;
    }
  }

  .subsciption-main-wrapper {
    display: contents;

    @include mq($from: desktop) {
      justify-content: space-evenly;
      display: flex;
      width: 100vw;
      align-items: center;
    }

    &-multiple-cards {
      display: block;
    }

    &-dark {
      background-color: $subscription-area-purple;
      margin-block-start: 9.6rem;
      margin-block-start: 4rem;
      display: flex;
      flex-direction: column-reverse;
      margin: auto;
      min-width: 100%;

      @include mq($from: 450px) {
        max-width: 80%;
      }
      @include mq($from: tabletportrait) {
        min-width: 80%;
      }
      @include mq($from: tabletlandscape) {
        padding: 0 6.4rem 6.4rem;
        min-width: 60%;
      }
      @include mq($from: desktop) {
        min-width: 90%;
      }
      @include mq($from: 1500) {
        min-width: 80%;
      }

      &.one-card-dark {
        padding-block-end: spacing(8);

        @include mq($from: desktop) {
          flex-direction: row;
          align-items: flex-start;
        }

        @include mq($from: 1700) {
          max-width: 70%;
        }
      }

      &.two-or-more-cards-dark {
        padding-block-end: spacing(8);

        @include mq($from: desktop) {
          flex-direction: row;
          align-items: flex-start;
        }
      }

      &.three-cards-dark {
        align-items: center;
        flex-direction: column-reverse;
      }
    }

    .illustration {
      display: flex;
      align-items: center;
      margin-block-start: spacing(4);

      @include mq($from: tabletportrait) {
        margin-block-start: spacing(2);
      }
      @include mq($from: desktop) {
        margin-block-start: spacing(10);
      }

      &-one-card {
        @include mq($until: desktop) {
          display: flex;
          justify-content: center;
        }
      }
    }

    .full-width {
      grid-column: span 2;

      @include mq($from: tabletlandscape) {
        grid-column: span 12;
      }
    }

    .subscription-header {
      padding-block-start: spacing(11);
      flex-direction: column;
      margin-block-end: spacing(4);
      color: $purple-50;

      &-multiple-cards {
        text-align: center;
        display: flex;
        align-items: center;
        width: 80%;
        margin: 0 auto;

        @include mq($from: desktop) {
          width: 55%;
        }
      }

      &-dark {
        max-width: 100%;

        @include mq($until: desktop) {
          margin: auto;
          margin-block-start: -3.2rem;
          padding-block-start: 0;
        }
        @include mq($from: desktop) {
          padding-block-start: 12.8rem;
        }
      }

      &-two-cards-dark {
        margin-block-start: -3.2rem;
        @include mq($from: desktop) {
          align-items: flex-start;
          max-width: 40%;
          padding-block-start: spacing(16);
        }
      }

      &-three-cards-dark {
        margin: 0 auto;
        display: block;

        @include mq($until: desktop) {
          margin-block-start: -3.2rem;
        }
        @include mq($from: desktop) {
          min-width: 100%;
          padding-block-start: 3.2rem;
        }
      }

      .description-items {
        display: flex;
        flex-direction: column;
        margin-block-start: 3.2rem;
        fill: $orange-50;
        text-align: center;

        @include mq($from: desktop) {
          text-align: start;
        }

        &-multiple-cards {
          margin-block-end: spacing(3);
          margin-block-start: spacing(1);
          flex-wrap: wrap;
          justify-content: center;

          @include mq($from: desktop) {
            flex-direction: row;
          }
        }

        &-one-cards-dark {
          display: block;
        }

        &-two-or-more-cards-dark {
          display: grid;
          margin-block-end: 0;

          @include mq($from: desktop) {
            min-width: 100%;
            justify-content: start;
          }
        }

        &-three-cards-dark {
          display: grid;
          margin-block-end: 0;

          @include mq($from: desktop) {
            display: flex;
            justify-content: center;
          }
        }

        .item-text {
          line-height: 2.4rem;
          margin-block-end: spacing(2);

          &-multiple-cards {
            padding: 0 spacing(4);
          }

          &-dark {
            color: $subscription-area-text-white;
            padding: 0;
            text-align: start;
          }

          &-three-cards-dark {
            @include mq($from: desktop) {
              margin: 0 2.2rem;
            }
          }

          :global(svg) {
            margin-inline-end: spacing(1);
            margin-block-start: -0.6rem;
          }
        }
      }
    }
  }

  .offer-eligibility {
    margin-block: 3.2rem -3.2rem;
    display: flex;
    justify-content: center;

    p {
      margin-block-end: 0;
      color: $purple-40;
    }
  }
</style>

{#if showDarkBackground}
  <header class="component-title-dark">
    <Heading tag="h2" type="title-xl"
      >{getTranslation(componentInformationKeys, 'priceplans.row1.title')}</Heading
    >
    <p>{getTranslation(componentInformationKeys, 'priceplans.row1.body')}</p>
  </header>
{/if}

<div
  class="subsciption-main-wrapper"
  class:subsciption-main-wrapper-dark={showDarkBackground}
  class:one-card-dark={showDarkBackground && !multipleSubscriptionCards}
  class:two-or-more-cards-dark={multipleSubscriptionCards && showDarkBackground}
  class:three-cards-dark={threeProductCards && showDarkBackground}
  class:subsciption-main-wrapper-multiple-cards={multipleSubscriptionCards}
>
  {#if !multipleSubscriptionCards && showDarkBackground}
    <div class="illustration" class:illustration-one-card={!multipleSubscriptionCards}>
      <IllustrationPhone />
    </div>
  {/if}
  <header
    class="subscription-header full-width"
    class:subscription-header-multiple-cards={multipleSubscriptionCards}
    class:subscription-header-dark={showDarkBackground}
    class:subscription-header-two-cards-dark={showDarkBackground && twoProductCards}
    class:subscription-header-three-cards-dark={threeProductCards && showDarkBackground}
  >
    <Heading tag="h2" type="title-xl" orange={showDarkBackground}>
      {getTranslation(componentInformationKeys, `priceplans.row1.bullettitle`)}
    </Heading>
    <ul
      class="description-items"
      class:description-items-multiple-cards={multipleSubscriptionCards}
      class:description-items-two-or-more-cards-dark={showDarkBackground && twoProductCards}
      class:description-items-three-cards-dark={showDarkBackground && threeProductCards}
      class:description-items-one-cards-dark={!multipleSubscriptionCards && showDarkBackground}
    >
      {#each getTranslation(componentInformationKeys, `priceplans.row1.bullets.v2`).split(';;') as bullet}
        <li
          class="item-text"
          class:item-text-multiple-cards={multipleSubscriptionCards}
          class:item-text-dark={showDarkBackground}
          class:item-text-three-cards-dark={threeProductCards && showDarkBackground}
        >
          <Icon iconName="checkmark" size="24" />{bullet}
        </li>
      {/each}
    </ul>
  </header>

  <SubscriptionSelectionArea {data} bind:cards {componentInformationKeys} />
</div>
{#if shouldShowOffer(data.firstRow.productGroups, hasActiveSubscription, data.isCustomerInactive)}
  <div class="offer-eligibility">
    <p>{getTranslation(componentInformationKeys, 'priceplans.offer.eligibility')}</p>
  </div>
{/if}
